import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/static/icons/close.svg'
import _imports_1 from '@/static/icons/chevron-right.svg'


const _hoisted_1 = { class: "facet-drawer" }
const _hoisted_2 = { class: "facet-drawer__page" }
const _hoisted_3 = { class: "facet-drawer__header" }
const _hoisted_4 = { class: "facet-drawer__title" }
const _hoisted_5 = {
  key: 0,
  class: "facet-drawer__active-facets"
}
const _hoisted_6 = {
  key: 0,
  class: "facet-drawer__line"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "facet-drawer__page" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "facet-drawer__title" }
const _hoisted_13 = {
  key: 0,
  class: "facet-drawer__active-facets"
}
const _hoisted_14 = {
  key: 1,
  class: "facet-drawer__line"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "facet-drawer__values" }

import { computed, nextTick, onMounted, ref } from 'vue';

import { FacetHit, getContext } from '@/composables/useDynamicProductListing';
import useWebsiteText from '@/composables/useWebsiteTexts';

import DrawerLayer from '../DrawerLayer.vue';
import FacetValuesRange from './FacetValues/FacetValuesRange.vue';


// For some reason, we have to register dynamic components using the non-setup tag
// or they won't be found.
import { defineComponent, watch } from 'vue';

import FacetListItems from './FacetListItems';
import Checkbox from '../forms/Checkbox.vue';
import FacetValues from './FacetValues';

const __default__ = defineComponent({
  components: {
    ...FacetListItems,
    ...FacetValues,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FacetDrawer',
  props: {
    showBackButton: { type: Boolean },
    drawerEl: null
  },
  setup(__props: any) {

const props = __props as {
  showBackButton: boolean;
  drawerEl: InstanceType<typeof DrawerLayer> | null;
}

_useCssVars(_ctx => ({
  "93bdd084": (_unref(lastFacetBorderBottom))
}))



const {
  listingData,
  activeFacets,
  listingFacets,
  isMobile,
  currentDrawerFacet,
  clearAllFacets,
  getFacetType,
  openFacetDrawer,
  closeFacetDrawer,
  toggleElementAnimation,
  clearFacet,
} = getContext();
const { websiteText } = useWebsiteText();

const facetsContainerEl = ref<HTMLDivElement | null>(null);
const hasFacetContainerElScroll = ref(false);
const displayFooterBorderTop = ref(false);
const closeButtonRef = ref<HTMLButtonElement | null>(null);
const backButtonRef = ref<HTMLButtonElement | null>(null);
const visitedFacetId = ref('');

const lastFacetBorderBottom = computed(() => {
  return hasFacetContainerElScroll.value
    ? 'none'
    : '1px solid var(--color-neutral-05)';
});

const footerText = computed(() => {
  const { hits } = listingData.value;
  const textId =
    hits === 1
      ? 'category__show_hits_count_singular'
      : 'category__show_hits_count';
  return websiteText(textId, {
    count: hits.toString(),
  }).value;
});

const numberOfActiveFacets = computed(() => {
  return activeFacets.reduce((sum, facet) => (sum += facet.values.length), 0);
});

const numberOfActiveFacetValues = computed(() => {
  return (
    activeFacets.find((facet) => facet.id === currentDrawerFacet.value?.id)
      ?.values.length || 0
  );
});

const rangeFacet = computed(() => {
  return listingFacets?.value.filter(
    (facet: FacetHit) => facet.type === 'Range'
  )?.[0];
});

watch(currentDrawerFacet, ((newVal) => {
  console.log(newVal);
  if (newVal && props.showBackButton) {
    visitedFacetId.value = newVal.id;
    setTimeout(() => {
      backButtonRef.value?.focus();
    }, 200);
  } else if (visitedFacetId.value) {
    const element = facetsContainerEl.value.querySelector(`[data-id=${visitedFacetId.value}]`);
    element?.focus();
  }
}));

function back() {
  openFacetDrawer();
}
function close() {
  const timeOut = isMobile.value ? 500 : 0;
  toggleElementAnimation(
    'slide-down',
    props.drawerEl?.$refs?.container as HTMLDivElement
  );
  setTimeout(() => {
    closeFacetDrawer();
  }, timeOut);
}

function isBooleanFacet(type) {
  return type?.toLowerCase() === 'boolean';
}

function onScroll() {
  if (!facetsContainerEl.value) return;
  const element = facetsContainerEl.value;

  const isBottom =
    element.scrollTop + element.clientHeight >= element.scrollHeight;

  hasFacetContainerElScroll.value = element.scrollHeight > element.clientHeight;

  displayFooterBorderTop.value = !isBottom && hasFacetContainerElScroll.value;
}

onMounted(() => {
  onScroll();
  closeButtonRef.value?.focus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["facet-drawer__container", { 'facet-drawer__container--values': _unref(currentDrawerFacet) }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(websiteText)('category__facets_all').value) + " ", 1),
            (_unref(numberOfActiveFacets))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(numberOfActiveFacets)), 1))
              : _createCommentVNode("", true)
          ]),
          (_unref(numberOfActiveFacets))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          (_unref(numberOfActiveFacets))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "facet-drawer__clear clean-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearAllFacets)()))
              }, _toDisplayString(_unref(websiteText)('category__facets_clear').value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "facet-drawer__close clean-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (close())),
            ref_key: "closeButtonRef",
            ref: closeButtonRef
          }, _hoisted_8, 512)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["facet-drawer__facets", {
            'facet-drawer__facets--no-scroll': _unref(currentDrawerFacet),
          }]),
          ref_key: "facetsContainerEl",
          ref: facetsContainerEl,
          onScroll: onScroll
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listingFacets), (facet) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: facet.id
            }, [
              (isBooleanFacet(facet.type))
                ? (_openBlock(), _createBlock(Checkbox, {
                    key: 0,
                    class: "facet-drawer__boolean",
                    text: facet.name,
                    modelValue: false
                  }, null, 8, ["text"]))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(`FacetListItem${_unref(getFacetType)(facet)}`), {
                    key: 1,
                    facet: facet,
                    "data-id": facet.id
                  }, null, 8, ["facet", "data-id"]))
            ], 64))
          }), 128)),
          (_unref(rangeFacet) && !_unref(currentDrawerFacet))
            ? (_openBlock(), _createBlock(FacetValuesRange, {
                key: 0,
                facet: _unref(rangeFacet)
              }, null, 8, ["facet"]))
            : _createCommentVNode("", true)
        ], 34)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(currentDrawerFacet))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["facet-drawer__header", { 'facet-drawer__header--back': __props.showBackButton }])
            }, [
              (__props.showBackButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref_key: "backButtonRef",
                    ref: backButtonRef,
                    class: "facet-drawer__back clean-button",
                    onClick: back
                  }, _hoisted_11, 512))
                : _createCommentVNode("", true),
              _createElementVNode("h2", _hoisted_12, [
                _createTextVNode(_toDisplayString(_unref(currentDrawerFacet)?.name) + " ", 1),
                (_unref(numberOfActiveFacetValues))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(numberOfActiveFacetValues)), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(numberOfActiveFacetValues))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true),
              (_unref(numberOfActiveFacetValues))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "facet-drawer__clear clean-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(clearFacet)(_unref(currentDrawerFacet)!)))
                  }, _toDisplayString(_unref(websiteText)('category__facets_clear').value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "facet-drawer__close clean-button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (close()))
              }, _hoisted_16)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          (_unref(currentDrawerFacet))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(`FacetValues${_unref(getFacetType)(_unref(currentDrawerFacet))}`), {
                key: 0,
                facet: _unref(currentDrawerFacet)
              }, null, 8, ["facet"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["facet-drawer__footer", { 'facet-drawer__footer-border': displayFooterBorderTop.value }])
    }, [
      _createElementVNode("button", {
        class: "facet-drawer__show-products primary-button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (close()))
      }, _toDisplayString(_unref(footerText)), 1)
    ], 2)
  ]))
}
}

})